// @flow
import React, { Component, lazy, Suspense } from "react";
import classNames from "classnames";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableFooter from "@material-ui/core/TableFooter";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { TableStylesClassesType } from "../../../global/styles/generalStyles";
import { tableStyles } from "../../../global/styles/generalStyles";
import { LoadingProgress, Paginations } from "imagus-components";

const SearchResultItem = lazy((): * => import("./SearchResultItem"));

const styles = (theme: DictionaryType): DictionaryType => ({
  ...tableStyles(theme),
  lineCursor: {
    cursor: "pointer"
  }
});

type SearchResultListClassesType = {
  ...TableStylesClassesType,
  lineCursor: DictionaryType
};

type SearchResultListPropsType = {
  classes: SearchResultListClassesType,
  searchList: Array<*>,
  activeItem: { [key: string]: string } | null,
  handlePersonClick: Function,
  setCurrentFace: Function,
  getFaceFromEnrolment: Function,
  displayTags: boolean,
  displayProbability: boolean
};

type SearchResultListStatesType = {
  page: number,
  rowsPerPage: number
};

class SearchResultList extends Component<
  SearchResultListPropsType,
  SearchResultListStatesType
> {
  constructor(props: SearchResultListPropsType) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 20
    };
  }

  onChangePage = (page: number): * => {
    this.setState({ page: page });
  };

  render(): * {
    const classes = this.props.classes;
    const { page, rowsPerPage } = this.state;

    const people =
      this.props.searchList &&
      this.props.searchList
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((result: *, i: number): * => {
          return (
            <Suspense fallback={<LoadingProgress />} key={page + "-" + i}>
              <SearchResultItem
                itemIndex={i}
                person={result}
                onClick={this.props.handlePersonClick.bind(this, result)}
                active={
                  result.enrolment_uid ===
                  (this.props.activeItem
                    ? this.props.activeItem.enrolment_uid
                    : null)
                }
                setCurrentFace={this.props.setCurrentFace}
                getFaceFromEnrolment={this.props.getFaceFromEnrolment}
                displayTags={this.props.displayTags}
                displayProbability={this.props.displayProbability}
              />
            </Suspense>
          );
        });

    return (
      <Paper>
        <Table className={classNames(classes.appTable, classes.center)}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.blueShine}>Enrolled Face</TableCell>
              <TableCell className={classes.blueShine}>Name</TableCell>
              <TableCell className={classes.blueShine}>Confidence</TableCell>
              <TableCell className={classes.blueShine}>
                {this.props.displayProbability ? "Probability" : "Distance"}
              </TableCell>
              {this.props.displayTags && (
                <TableCell className={classes.blueShine}>Tags</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>{people}</TableBody>
          <TableFooter>
            <TableRow>
              <Paginations
                page={page}
                count={this.props.searchList.length}
                rowsPerPage={rowsPerPage}
                onChangePage={this.onChangePage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

export default withStyles(styles)(SearchResultList);
